var _style, _style2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingAnimated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      margin: "auto",
      background: "transparent",
      display: "block",
      shapeRendering: "auto"
    },
    width: 280,
    height: 250,
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  text {\n    text-anchor: middle; font-size: 58px; opacity: 0;\n  }\n")), /*#__PURE__*/React.createElement("g", {
    style: {
      transformOrigin: "140px 125px",
      transform: "scale(0.725)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,125)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "-156.08px -7.43375px",
      animation: "1s linear -0.6s infinite normal forwards running breath-8cee1472-e11a-4bd8-b017-d8bfa0595c6e"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.20-59.20L13.20-13.76L13.20-13.76Q13.20-9.44 15-7.36L15-7.36L15-7.36Q16.80-5.28 20-5.28L20-5.28L20-5.28Q21.52-5.28 22.96-5.64L22.96-5.64L22.96-5.64Q24.40-6 25.52-6.48L25.52-6.48L27.28-0.64L27.28-0.64Q25.84 0 23.72 0.48L23.72 0.48L23.72 0.48Q21.60 0.96 19.04 0.96L19.04 0.96L19.04 0.96Q16.24 0.96 13.88 0.16L13.88 0.16L13.88 0.16Q11.52-0.64 9.76-2.32L9.76-2.32L9.76-2.32Q8-4 7-6.64L7-6.64L7-6.64Q6-9.28 6-13.04L6-13.04L6-59.20L13.20-59.20",
    fill: "#8651cc",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-172.719970703125,21.68625119295987)",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "-122.32px 0.88625px",
      animation: "1s linear -0.54s infinite normal forwards running breath-8cee1472-e11a-4bd8-b017-d8bfa0595c6e"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.76-20.80L63.76-20.80L63.76-20.80Q63.76-23.92 62.76-26.72L62.76-26.72L62.76-26.72Q61.76-29.52 59.96-31.60L59.96-31.60L59.96-31.60Q58.16-33.68 55.72-34.92L55.72-34.92L55.72-34.92Q53.28-36.16 50.40-36.16L50.40-36.16L50.40-36.16Q44.08-36.16 40.56-32L40.56-32L40.56-32Q37.04-27.84 37.04-20.96L37.04-20.96L37.04-20.96Q37.04-17.84 38.04-15L38.04-15L38.04-15Q39.04-12.16 40.84-10.04L40.84-10.04L40.84-10.04Q42.64-7.92 45.08-6.68L45.08-6.68L45.08-6.68Q47.52-5.44 50.40-5.44L50.40-5.44L50.40-5.44Q53.52-5.44 56-6.56L56-6.56L56-6.56Q58.48-7.68 60.20-9.72L60.20-9.72L60.20-9.72Q61.92-11.76 62.84-14.56L62.84-14.56L62.84-14.56Q63.76-17.36 63.76-20.80zM29.68-20.80L29.68-20.80L29.68-20.80Q29.68-25.84 31.28-29.88L31.28-29.88L31.28-29.88Q32.88-33.92 35.64-36.72L35.64-36.72L35.64-36.72Q38.40-39.52 42.20-41.04L42.20-41.04L42.20-41.04Q46-42.56 50.40-42.56L50.40-42.56L50.40-42.56Q54.72-42.56 58.52-41.04L58.52-41.04L58.52-41.04Q62.32-39.52 65.12-36.72L65.12-36.72L65.12-36.72Q67.92-33.92 69.52-29.92L69.52-29.92L69.52-29.92Q71.12-25.92 71.12-20.96L71.12-20.96L71.12-20.96Q71.12-16 69.56-11.96L69.56-11.96L69.56-11.96Q68-7.92 65.20-5.04L65.20-5.04L65.20-5.04Q62.40-2.16 58.60-0.60L58.60-0.60L58.60-0.60Q54.80 0.96 50.40 0.96L50.40 0.96L50.40 0.96Q45.92 0.96 42.12-0.64L42.12-0.64L42.12-0.64Q38.32-2.24 35.56-5.12L35.56-5.12L35.56-5.12Q32.80-8 31.24-12L31.24-12L31.24-12Q29.68-16 29.68-20.80",
    fill: "#8651cc",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-172.719970703125,21.68625119295987)",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "-73.52px 0.88625px",
      animation: "1s linear -0.48s infinite normal forwards running breath-8cee1472-e11a-4bd8-b017-d8bfa0595c6e"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.92-20.56L77.92-20.56L77.92-20.56Q77.92-25.20 79.36-29.24L79.36-29.24L79.36-29.24Q80.80-33.28 83.40-36.24L83.40-36.24L83.40-36.24Q86-39.20 89.64-40.88L89.64-40.88L89.64-40.88Q93.28-42.56 97.60-42.56L97.60-42.56L97.60-42.56Q101.20-42.56 104.12-41.32L104.12-41.32L104.12-41.32Q107.04-40.08 109.20-38.24L109.20-38.24L109.20-41.60L115.76-41.60L115.76-10.08L115.76-10.08Q115.76-7.04 117.24-6.12L117.24-6.12L117.24-6.12Q118.72-5.20 120.48-5.20L120.48-5.20L118.96 0.40L118.96 0.40Q111.28 0.40 109.68-5.84L109.68-5.84L109.68-5.84Q108.72-4.56 107.48-3.32L107.48-3.32L107.48-3.32Q106.24-2.08 104.64-1.12L104.64-1.12L104.64-1.12Q103.04-0.16 101.04 0.40L101.04 0.40L101.04 0.40Q99.04 0.96 96.64 0.96L96.64 0.96L96.64 0.96Q92.72 0.96 89.32-0.56L89.32-0.56L89.32-0.56Q85.92-2.08 83.40-4.88L83.40-4.88L83.40-4.88Q80.88-7.68 79.40-11.64L79.40-11.64L79.40-11.64Q77.92-15.60 77.92-20.56zM98.24-5.44L98.24-5.44L98.24-5.44Q101.28-5.44 104-6.88L104-6.88L104-6.88Q106.72-8.32 108.56-10.64L108.56-10.64L108.56-32.96L108.56-32.96Q106.40-34.48 103.80-35.40L103.80-35.40L103.80-35.40Q101.20-36.32 98.32-36.32L98.32-36.32L98.32-36.32Q95.44-36.32 93.04-35.20L93.04-35.20L93.04-35.20Q90.64-34.08 88.92-32.04L88.92-32.04L88.92-32.04Q87.20-30 86.24-27.12L86.24-27.12L86.24-27.12Q85.28-24.24 85.28-20.80L85.28-20.80L85.28-20.80Q85.28-17.44 86.24-14.60L86.24-14.60L86.24-14.60Q87.20-11.76 88.96-9.72L88.96-9.72L88.96-9.72Q90.72-7.68 93.08-6.56L93.08-6.56L93.08-6.56Q95.44-5.44 98.24-5.44",
    fill: "#8651cc",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-172.719970703125,21.68625119295987)",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "-25.12px -7.43375px",
      animation: "1s linear -0.42s infinite normal forwards running breath-8cee1472-e11a-4bd8-b017-d8bfa0595c6e"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.04 0.96L145.04 0.96L145.04 0.96Q141.20 0.96 137.80-0.56L137.80-0.56L137.80-0.56Q134.40-2.08 131.88-4.88L131.88-4.88L131.88-4.88Q129.36-7.68 127.92-11.64L127.92-11.64L127.92-11.64Q126.48-15.60 126.48-20.56L126.48-20.56L126.48-20.56Q126.48-25.28 127.96-29.32L127.96-29.32L127.96-29.32Q129.44-33.36 131.96-36.28L131.96-36.28L131.96-36.28Q134.48-39.20 137.84-40.88L137.84-40.88L137.84-40.88Q141.20-42.56 144.96-42.56L144.96-42.56L144.96-42.56Q149.12-42.56 152.12-40.88L152.12-40.88L152.12-40.88Q155.12-39.20 156.80-37.44L156.80-37.44L156.80-59.20L164-59.20L164-10.08L164-10.08Q164-7.04 165.48-6.12L165.48-6.12L165.48-6.12Q166.96-5.20 168.72-5.20L168.72-5.20L167.20 0.40L167.20 0.40Q159.60 0.40 157.92-5.68L157.92-5.68L157.92-5.68Q156.08-3.12 152.96-1.08L152.96-1.08L152.96-1.08Q149.84 0.96 145.04 0.96zM146.64-5.44L146.64-5.44L146.64-5.44Q149.60-5.44 152.28-6.84L152.28-6.84L152.28-6.84Q154.96-8.24 156.80-10.48L156.80-10.48L156.80-31.12L156.80-31.12Q155.28-33.04 152.60-34.68L152.60-34.68L152.60-34.68Q149.92-36.32 146.56-36.32L146.56-36.32L146.56-36.32Q143.68-36.32 141.32-35.12L141.32-35.12L141.32-35.12Q138.96-33.92 137.28-31.84L137.28-31.84L137.28-31.84Q135.60-29.76 134.72-26.92L134.72-26.92L134.72-26.92Q133.84-24.08 133.84-20.80L133.84-20.80L133.84-20.80Q133.84-17.44 134.80-14.64L134.80-14.64L134.80-14.64Q135.76-11.84 137.48-9.80L137.48-9.80L137.48-9.80Q139.20-7.76 141.56-6.60L141.56-6.60L141.56-6.60Q143.92-5.44 146.64-5.44",
    fill: "#8651cc",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-172.719970703125,21.68625119295987)",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "9.20004px 0.886251px",
      animation: "1s linear -0.36s infinite normal forwards running breath-8cee1472-e11a-4bd8-b017-d8bfa0595c6e"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.52-41.60L185.52 0L178.32 0L178.32-41.60L185.52-41.60",
    fill: "#8651cc",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-172.719970703125,21.68625119295987)",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "9.20004px -32.0737px",
      animation: "1s linear -0.3s infinite normal forwards running breath-8cee1472-e11a-4bd8-b017-d8bfa0595c6e"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.92-48.72L181.92-48.72L181.92-48.72Q179.84-48.72 178.36-50.20L178.36-50.20L178.36-50.20Q176.88-51.68 176.88-53.76L176.88-53.76L176.88-53.76Q176.88-56.08 178.24-57.44L178.24-57.44L178.24-57.44Q179.60-58.80 181.92-58.80L181.92-58.80L181.92-58.80Q184.00-58.80 185.48-57.32L185.48-57.32L185.48-57.32Q186.96-55.84 186.96-53.76L186.96-53.76L186.96-53.76Q186.96-51.44 185.60-50.08L185.60-50.08L185.60-50.08Q184.24-48.72 181.92-48.72",
    fill: "#8651cc",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-172.719970703125,21.68625119295987)",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "43.08px 0.40625px",
      animation: "1s linear -0.24s infinite normal forwards running breath-8cee1472-e11a-4bd8-b017-d8bfa0595c6e"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.28-41.60L205.28-34.64L205.28-34.64Q207.52-38 211.00-40.28L211.00-40.28L211.00-40.28Q214.48-42.56 219.28-42.56L219.28-42.56L219.28-42.56Q226.32-42.56 229.80-38.32L229.80-38.32L229.80-38.32Q233.28-34.08 233.28-27.12L233.28-27.12L233.28 0L226.08 0L226.08-26.32L226.08-26.32Q226.08-30.88 224-33.56L224-33.56L224-33.56Q221.92-36.24 218.08-36.24L218.08-36.24L218.08-36.24Q216.24-36.24 214.48-35.56L214.48-35.56L214.48-35.56Q212.72-34.88 211.08-33.68L211.08-33.68L211.08-33.68Q209.44-32.48 208.04-30.88L208.04-30.88L208.04-30.88Q206.64-29.28 205.52-27.52L205.52-27.52L205.52 0L198.32 0L198.32-41.60L205.28-41.60",
    fill: "#8651cc",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-172.719970703125,21.68625119295987)",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "88.76px 9.68625px",
      animation: "1s linear -0.18s infinite normal forwards running breath-8cee1472-e11a-4bd8-b017-d8bfa0595c6e"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.16-42.56L262.16-42.56L262.16-42.56Q265.76-42.56 268.60-41.36L268.60-41.36L268.60-41.36Q271.44-40.16 273.52-38.40L273.52-38.40L273.52-41.60L280.08-41.60L280.08-0.96L280.08-0.96Q280.08 4.24 278.72 7.92L278.72 7.92L278.72 7.92Q277.36 11.60 274.84 13.96L274.84 13.96L274.84 13.96Q272.32 16.32 268.80 17.44L268.80 17.44L268.80 17.44Q265.28 18.56 260.96 18.56L260.96 18.56L260.96 18.56Q257.20 18.56 253.76 17.68L253.76 17.68L253.76 17.68Q250.32 16.80 247.60 15.04L247.60 15.04L250.24 8.80L250.24 8.80Q252.16 10.32 254.72 11.32L254.72 11.32L254.72 11.32Q257.28 12.32 260.96 12.32L260.96 12.32L260.96 12.32Q266.64 12.32 269.88 9.36L269.88 9.36L269.88 9.36Q273.12 6.40 273.12-0.24L273.12-0.24L273.12-5.36L273.12-5.36Q271.52-3.44 268.52-1.72L268.52-1.72L268.52-1.72Q265.52 0 261.36 0L261.36 0L261.36 0Q257.84 0 254.48-1.40L254.48-1.40L254.48-1.40Q251.12-2.80 248.56-5.48L248.56-5.48L248.56-5.48Q246.00-8.16 244.44-12.04L244.44-12.04L244.44-12.04Q242.88-15.92 242.88-20.96L242.88-20.96L242.88-20.96Q242.88-25.60 244.40-29.56L244.40-29.56L244.40-29.56Q245.92-33.52 248.52-36.40L248.52-36.40L248.52-36.40Q251.12-39.28 254.64-40.92L254.64-40.92L254.64-40.92Q258.16-42.56 262.16-42.56zM262.96-6.40L262.96-6.40L262.96-6.40Q266.16-6.40 268.72-7.84L268.72-7.84L268.72-7.84Q271.28-9.28 272.88-11.20L272.88-11.20L272.88-32.96L272.88-32.96Q271.04-34.24 268.64-35.28L268.64-35.28L268.64-35.28Q266.24-36.32 262.88-36.32L262.88-36.32L262.88-36.32Q260.40-36.32 258.12-35.32L258.12-35.32L258.12-35.32Q255.84-34.32 254.08-32.40L254.08-32.40L254.08-32.40Q252.32-30.48 251.28-27.72L251.28-27.72L251.28-27.72Q250.24-24.96 250.24-21.36L250.24-21.36L250.24-21.36Q250.24-17.92 251.28-15.16L251.28-15.16L251.28-15.16Q252.32-12.40 254.08-10.44L254.08-10.44L254.08-10.44Q255.84-8.48 258.12-7.44L258.12-7.44L258.12-7.44Q260.40-6.40 262.96-6.40",
    fill: "#8651cc",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-172.719970703125,21.68625119295987)",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "125.36px 17.2863px",
      animation: "1s linear -0.12s infinite normal forwards running breath-8cee1472-e11a-4bd8-b017-d8bfa0595c6e"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.72-4.40L292.72-4.40L292.72-4.40Q292.72-6.88 294.12-8.32L294.12-8.32L294.12-8.32Q295.52-9.76 298.08-9.76L298.08-9.76L298.08-9.76Q300.16-9.76 301.80-8.16L301.80-8.16L301.80-8.16Q303.44-6.56 303.44-4.40L303.44-4.40L303.44-4.40Q303.44-2 301.92-0.52L301.92-0.52L301.92-0.52Q300.40 0.96 298.08 0.96L298.08 0.96L298.08 0.96Q295.92 0.96 294.32-0.64L294.32-0.64L294.32-0.64Q292.72-2.24 292.72-4.40",
    fill: "#8651cc",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-172.719970703125,21.68625119295987)",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "149.36px 17.2863px",
      animation: "1s linear -0.06s infinite normal forwards running breath-8cee1472-e11a-4bd8-b017-d8bfa0595c6e"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.72-4.40L316.72-4.40L316.72-4.40Q316.72-6.88 318.12-8.32L318.12-8.32L318.12-8.32Q319.52-9.76 322.08-9.76L322.08-9.76L322.08-9.76Q324.16-9.76 325.80-8.16L325.80-8.16L325.80-8.16Q327.44-6.56 327.44-4.40L327.44-4.40L327.44-4.40Q327.44-2 325.92-0.52L325.92-0.52L325.92-0.52Q324.40 0.96 322.08 0.96L322.08 0.96L322.08 0.96Q319.92 0.96 318.32-0.64L318.32-0.64L318.32-0.64Q316.72-2.24 316.72-4.40",
    fill: "#8651cc",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-172.719970703125,21.68625119295987)",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "173.36px 17.2863px",
      animation: "1s linear 0s infinite normal forwards running breath-8cee1472-e11a-4bd8-b017-d8bfa0595c6e"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.72-4.40L340.72-4.40L340.72-4.40Q340.72-6.88 342.12-8.32L342.12-8.32L342.12-8.32Q343.52-9.76 346.08-9.76L346.08-9.76L346.08-9.76Q348.16-9.76 349.80-8.16L349.80-8.16L349.80-8.16Q351.44-6.56 351.44-4.40L351.44-4.40L351.44-4.40Q351.44-2 349.92-0.52L349.92-0.52L349.92-0.52Q348.40 0.96 346.08 0.96L346.08 0.96L346.08 0.96Q343.92 0.96 342.32-0.64L342.32-0.64L342.32-0.64Q340.72-2.24 340.72-4.40",
    fill: "#8651cc",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-172.719970703125,21.68625119295987)",
    style: {
      fill: "#FFFFFF"
    }
  }))))), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    id: "breath-8cee1472-e11a-4bd8-b017-d8bfa0595c6e",
    "data-anikit": ""
  }, "@keyframes breath-8cee1472-e11a-4bd8-b017-d8bfa0595c6e\n{\n  0% {\n    animation-timing-function: cubic-bezier(0.9647,0.2413,-0.0705,0.7911);\n    transform: scale(0.9099999999999999);\n  }\n  51% {\n    animation-timing-function: cubic-bezier(0.9226,0.2631,-0.0308,0.7628);\n    transform: scale(1.02994);\n  }\n  100% {\n    transform: scale(0.9099999999999999);\n  }\n}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingAnimated);
export default __webpack_public_path__ + "static/media/loading-animated.c20315a43791c0ff2845f0b5eb85de76.svg";
export { ForwardRef as ReactComponent };